import apiClient from './apiClient'


const getSchemeUsers = (tenant, schemeId) => {
  return apiClient.get(`/${tenant}/SchemeUser/${schemeId}`)
}

const getSchemeUser = (tenant, schemeId, userId) => {
  return apiClient.get(`/${tenant}/SchemeUser/${schemeId}/${userId}`)
}

const createSchemeUser = (tenant, schemeUser) => {
  return apiClient.post(`/${tenant}/SchemeUser`, schemeUser)
}

const updateSchemeUser = (tenant, schemeId, userId, schemeUser) => {
  return apiClient.put(`/${tenant}/SchemeUser/${schemeId}/${userId}`, schemeUser)
}

const deleteSchemeUser = (tenant, schemeId, userId) => {
  return apiClient.delete(`/${tenant}/SchemeUser/${schemeId}/${userId}`)
}


export default {
  getSchemeUsers,
  getSchemeUser,
  createSchemeUser,
  updateSchemeUser,
  deleteSchemeUser
}
